<template>
  <b-row v-if="$route.name === 'EXCMDeviceStateCreate'">
    <b-col cols="12">
      <b-card>
        <EXCMDeviceStateForm
          :handle-submit="onSendForm"
          :handle-update-field="updateField"
          :values="item"
          :errors="violations" />
      </b-card>
    </b-col>
  </b-row>
  <b-row v-else>
    <b-col cols="12">
      <EXCMDeviceStateForm
        :handle-submit="onSendForm"
        :handle-update-field="updateField"
        :values="item"
        :id-device="idDevice"
        :errors="violations" />
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMDeviceStateForm from './Form'

const { mapGetters, mapActions } = createNamespacedHelpers('excmdevicestate/create')

export default {
  components: {
    EXCMDeviceStateForm
  },

  props: {
    idDevice: {
      required: false,
      default: null
    }
  },

  data () {
    return {
      item: {
        readDate: this.$moment().format('YYYY-MM-DD'),
        idDevice: this.idDevice,
        counterMono: 0,
        counterColor: 0,
        counterCopy: 0,
        counterPrint: 0,
        counterA3: 0,
        counterA4: 0,
        counterA3Mono: 0,
        counterA4Mono: 0,
        counterA3Color: 0,
        counterA4Color: 0,
        tonerLevelBk: 0,
        tonerLevelC: 0,
        tonerLevelM: 0,
        tonerLevelY: 0,
        maintenanceStatus: '',
        notes: ''
      }
    }
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
      } else this.$router.go(-1)
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      let item = Object.assign({}, this.item)
      if (item.readDate === '') {
        item.readDate = this.$moment().format('YYYY-MM-DD HH:mm')
      } else {
        item.readDate = this.$moment(item.readDate).format('YYYY-MM-DD HH:mm')
      }
      item.counterPrint = parseInt(item.counterPrint)
      item.counterMono = parseInt(item.counterMono)
      item.counterColor = parseInt(item.counterColor)
      item.counterCopy = parseInt(item.counterCopy)
      item.counterA3 = parseInt(item.counterA3)
      item.counterA4 = parseInt(item.counterA4)
      item.counterA3Mono = parseInt(item.counterA3Mono)
      item.counterA4Mono = parseInt(item.counterA4Mono)
      item.counterA3Color = parseInt(item.counterA3Color)
      item.counterA4Color = parseInt(item.counterA4Color)
      item.tonerLevelBk = parseInt(item.tonerLevelBk)
      item.tonerLevelC = parseInt(item.tonerLevelC)
      item.tonerLevelM = parseInt(item.tonerLevelM)
      item.tonerLevelY = parseInt(item.tonerLevelY)
      this.create(item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
